import { render, staticRenderFns } from "./created-special-data.vue?vue&type=template&id=6a57c00d"
import script from "./created-special-data.vue?vue&type=script&lang=ts"
export * from "./created-special-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports